import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { FalkeTekLogo } from "../components/Brand";
import { fireConfetti } from "../components/Confetti";

export default function PublicReferral() {
  const { slug } = useParams();
  const [empfehler, setEmpfehler] = useState(null);
  const [form, setForm] = useState({ empfohlener_name: "", empfohlener_telefon: "", empfohlener_email: "", notiz: "", einwilligung_empfohlener: false });
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get(`/public/empfehler/${slug}`).then((r) => setEmpfehler(r.data)).catch(() => setEmpfehler(false));
  }, [slug]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/public/empfehlungen", { ...form, empfehler_slug: slug });
      fireConfetti("strong");
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  if (empfehler === null) return <div className="min-h-screen flex items-center justify-center text-falke-blue">Lade…</div>;
  if (empfehler === false) return (
    <div className="min-h-screen flex items-center justify-center p-6 text-center">
      <div>
        <h1 className="text-2xl font-heading text-falke-blue">Empfehlungs-Link nicht gefunden</h1>
        <Link to="/login" className="text-falke-orange mt-3 inline-block">Zum Login</Link>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-falke-warmwhite">
      <header className="px-6 py-5 bg-white border-b border-falke-blue/10">
        <FalkeTekLogo />
      </header>
      <div className="max-w-2xl mx-auto px-4 py-8">
        <div className="falke-card p-8">
          <div className="text-xs uppercase tracking-wider text-falke-orange mb-2">Persönliche Empfehlung</div>
          <h1 className="text-3xl font-heading font-bold text-falke-blue">{empfehler.name} empfiehlt dir FalkeTek</h1>
          <p className="text-falke-anthracite/70 mt-2">Hinterlasse hier deine Kontaktdaten – ein Berater meldet sich bei dir.</p>

          {done ? (
            <div className="mt-8 p-6 rounded-xl bg-falke-success/10 text-falke-success text-center" data-testid="public-success">
              <div className="text-2xl font-heading font-bold">Vielen Dank!</div>
              <p className="text-sm mt-2">Wir melden uns bei dir innerhalb der nächsten Werktage.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="public-form">
              <input required placeholder="Name *" value={form.empfohlener_name} onChange={(e) => setForm({ ...form, empfohlener_name: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-falke-blue/15" data-testid="public-name" />
              <input required placeholder="Telefon *" value={form.empfohlener_telefon} onChange={(e) => setForm({ ...form, empfohlener_telefon: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-falke-blue/15" data-testid="public-tel" />
              <input type="email" placeholder="E-Mail" value={form.empfohlener_email} onChange={(e) => setForm({ ...form, empfohlener_email: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-falke-blue/15" data-testid="public-email" />
              <textarea rows={3} placeholder="Persönliche Notiz (optional)" value={form.notiz} onChange={(e) => setForm({ ...form, notiz: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-falke-blue/15" />
              <label className="flex items-start gap-2 text-sm">
                <input required type="checkbox" checked={form.einwilligung_empfohlener} onChange={(e) => setForm({ ...form, einwilligung_empfohlener: e.target.checked })} className="mt-1 w-4 h-4 accent-falke-orange" data-testid="public-dsgvo" />
                <span>Ich bin damit einverstanden, dass FalkeTek mich kontaktiert (DSGVO).</span>
              </label>
              {error && <div className="text-sm text-red-600" data-testid="public-error">{error}</div>}
              <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="public-submit">{loading ? "Sende…" : "Absenden"}</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
